"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FoldersRoute {
    static get path() {
        return `/folders`;
    }
    static get friendlyName() {
        return 'folderHeader';
    }
}
exports.default = FoldersRoute;
